module.exports = __webpack_public_path__ + "static/media/Kaeya.cbce61ef.png";